(function() {
    'use strict';

a3_pilot_reports.directive('ssr',ssr);

    
    
   /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name ssr
   * @restrict EA
   * @description
   *   Implementation of issues
   *
   *   Initialize the special service template
   * @attr {String} format The name of the format to initialize the ssr.
   * @example
   *   Usage:
   *   <div ssr format="compact"></div>
   * @ngInject
   */    
function ssr($sce,ssrCodes, showRecomendedWaterAcTypes) {

	
		return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/ssr.tpl.html',
            scope: {
                paxInfo: '=',
                flight: '='
            },
            link: function ($scope, element, attrs) {
                $scope.format = attrs.format;
                
                $scope.FQTVGold = detailedInfo('FQTVGold');
                $scope.FQTVSilver = detailedInfo('FQTVSilver');
                $scope.UMNR = detailedInfo('UMNR');
                $scope.PRM = detailedInfo('WCBD,WCBW,WCHC,WCHR,WCHS,WCLB,WCMP,WCOB')
                $scope.DEAF = detailedInfo('DEAF')
                $scope.BLND = detailedInfo('BLND')
                $scope.DPNA = detailedInfo('DPNA')
                $scope.DEP = detailedInfo('DEPA,DEPU,ESCD')
                $scope.INAD = detailedInfo('INAD')
                $scope.MEDA = detailedInfo('AOXY,MEDA,MEQT,POXY')
                $scope.CBBG = detailedInfo('CBBG')
                $scope.OTH =  detailedInfo('AVIH,BIKE,EMIG,ESAN,EXST,FAMS,GPST,HAJJ,PETC,SVAN,WEAP,XBGS,MAAS')
                $scope.VIP = detailedInfo('VIP');

                $scope.showFQTVGold = false;
                $scope.showFQTVSilver = false;
                $scope.showUMNR = false;
                $scope.showPRM = false;
                $scope.showDEAF = false;
                $scope.showBLND = false;
                $scope.showDPNA = false;
                $scope.showDEP = false;
                $scope.showINAD = false;
                $scope.showMEDA = false;
                $scope.showCBBG = false;
                $scope.showOTH = false;
                $scope.showVIP = false;
                
                                
                $scope.waterQuantity =  getWaterQuantity();
                $scope.showRecomendedWater = showRecomendedWater(); 
                    
                function showRecomendedWater(){
                    return showRecomendedWaterAcTypes.includes($scope.flight.AcType);
                }
                
                function getWaterQuantity(){
                    var totalPax = $scope.flight.BookedC + $scope.flight.BookedY;
                    var startDate = moment($scope.flight.ScheduledDeparture);
                    var endDate = moment($scope.flight.ScheduledArrival);
                    var duration = moment.duration(endDate.diff(startDate)).asHours();
                    var waterQuantity = (0,18 * totalPax * duration)/200;
                    var formattedwaterQuantity = waterQuantity.toString().substring(0,4);
                    return formattedwaterQuantity;
                }
                
                
                function detailedInfo(properties){
                    var propertiesArray = properties.split(',');
                    var htmlPopover = ''
                    if($scope.paxInfo && $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryY){
                        if(propertiesArray.length>1){
                            htmlPopover =   '<div class="row"><div class="col-sm-offset-9  col-xs-offset-8 col-xs-1"><strong>C</strong></div><div class=" col-xs-1"><strong>Y</strong></div><div class=" col-xs-1"><strong>Total</strong></div> </div>';

                            angular.forEach(propertiesArray,function(property){
                                
                             var Total = $scope.paxInfo.PassengerSummaryC[('Total'+property)]  + $scope.paxInfo.PassengerSummaryY[('Total'+property)];
                                if(Total>0){
                                    var code = '';
                                for (var i = 0; i < ssrCodes.length ; i++){
                                    if(ssrCodes[i].code == property){
                                        code = ssrCodes[i].description;
                                    }
                                }
                                htmlPopover = htmlPopover + '<div class="row"> <strong class="col-xs-2">' + property + "</strong>";
                                htmlPopover = htmlPopover + '<span class="col-sm-7 col-xs-6 text-medium">' + code + "</span>";
                                htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryC[property] + "</div>";
                                 htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryY[property] + "</div>";
                                
                                htmlPopover = htmlPopover + '<div class="col-xs-1">' 
                                    + Total
                                    + "</div></div>";
                                }
                            })
                        }else{
                            angular.forEach(propertiesArray,function(property){
                                var Total = $scope.paxInfo.PassengerSummaryC[('Total'+property)]  + $scope.paxInfo.PassengerSummaryY[('Total'+property)];
                               htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + $scope.paxInfo.PassengerSummaryC[property] + '</strong>';
                               htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + $scope.paxInfo.PassengerSummaryY[property] + '</strong>';
                                if(Total){
                                    htmlPopover = htmlPopover + ' <strong class="col-xs-4 col-md-3"> Total ' + Total + '</strong>';
                                 }
                                  htmlPopover = htmlPopover + '</div>';
                            })
                        }
                    }
                    
                    return $sce.trustAsHtml(htmlPopover);
                }
            }
		}
	}

    


})();
	